import React, { useState } from "react";
import { RiHeartAddLine } from "react-icons/ri";
import { FaHeart } from "react-icons/fa";
import defaultImage from "../../assets/resort.png";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { toggleWishlistItem } from "../../redux/slice/wishlistSlice";
import { motion } from "framer-motion";

const ServiceCard = ({
  id,
  title,
  description,
  image,
  price,
  type,
  onClick,
  cartItems, // Receive cartItems as a prop
}) => {
  const [imageError, setImageError] = useState(false);
  const dispatch = useDispatch();

  const { items: wishlistItems, loading } = useSelector((state) => state.wishlist || { items: [], loading: false });

  const isFavorite = wishlistItems.some((item) => item.item_id === id && item.item_type === type);

  const isAlreadyInCart = (cartItems || []).some((item) => item.item_id === id);

  const user = useSelector((state) => state.auth.user);

  const handleWishlist = async (e) => {
    e.stopPropagation();
    if (loading) return;
    if (!user) {
      toast.error("Unauthorized request. Please Sign In");
      return;
    }
    try {
      const action = isFavorite ? "delete" : "create";
      if (action === "create") {
        const response = await dispatch(toggleWishlistItem({ id, type })).unwrap();
        console.log(response)
        toast.dismiss();
        toast.success("Added to wishlist");
      } else {
        await dispatch(toggleWishlistItem({ id, type })).unwrap();
        toast.dismiss();
        toast.success("Removed from wishlist");
      }
    } catch (error) {
      toast.dismiss();
      const errorMessage = error?.message || error?.data?.message || "Operation failed";
      if (errorMessage === "Item already exists in wishlist") {
        toast.success("Item is already in wishlist");
      } else {
        toast.error(errorMessage);
      }
    }
  };

  return (
    <div className="relative flex w-full md:p-3 p-2 bg-white/70 rounded-2xl border border-gray-300 shadow-md overflow-hidden cursor-pointer hover:shadow-lg transition-shadow" onClick={onClick}>
      <div className="md:size-48 w-32 h-32 flex-shrink-0 rounded-xl overflow-hidden mr-1">
        <img src={!imageError && image ? image.url : defaultImage} alt={title} className="object-cover w-full h-full rounded-xl transition-opacity duration-200" onError={() => setImageError(true)} />
      </div>

      <motion.button
        onClick={handleWishlist}
        className="absolute top-2 right-2 md:p-2 p-1 bg-gray-200 rounded-full transition-all duration-200 hover:bg-gray-300"
        aria-label={isFavorite ? "Remove from favorites" : "Add to favorites"}
        whileTap={{ scale: 0.8 }}
        whileHover={{ scale: 1, rotate: [0, -10, 10, 0] }}
        transition={{ type: "spring", stiffness: 500, damping: 10 }}
      >
        <motion.div
          key={isFavorite ? "filled" : "outline"}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.5 }}
          transition={{ type: "spring", stiffness: 200, damping: 15 }}
        >
          {!isFavorite ? (
            <motion.div whileHover={{ scale: 1.1 }} transition={{ duration: 0.3 }}>
              <RiHeartAddLine className="md:w-6 md:h-6 w-5 h-5 text-textprimary" />
            </motion.div>
          ) : (
            <motion.div
              // animate={{ scale: [1, 1.05, 1] }}
              transition={{
                repeat: Infinity,
                duration: 1.2,
                ease: "easeInOut",
              }}
            >
              <FaHeart className="md:w-6 md:h-6 w-5 h-5 text-red-500 drop-shadow-lg" />
            </motion.div>
          )}
        </motion.div>
      </motion.button>

      <div className="flex flex-col flex-grow py-1 md:py-1 md:px-4 px-1 min-w-0">
        <div className="flex-grow min-w-0 mb-4">
          <h2 className="md:text-xl text-sm font-medium text-textDarkPrimary mb-2 line-clamp-1 md:line-clamp-2">{title}</h2>
          <p className="md:text-sm text-xs text-gray-500 line-clamp-2 md:line-clamp-3">{description}</p>
        </div>

        <div className="flex justify-between items-start md:items-center md:gap-4 gap-2 mt-auto">
          <div className="flex items-baseline gap-1">
            <span className="font-bold text-textprimary text-sm md:text-xl">₹ {price.toLocaleString()}</span>
          </div>
          <button
            className={`${
              isAlreadyInCart ? "bg-[#199819] hover:bg-[#158715]" : "bg-buttonprimary hover:bg-buttonhoverPrimary hover:scale-105"
            } shadow-xl text-white md:text-sm text-xs rounded-full md:px-3 md:py-2 py-1 px-2 font-medium transition-all duration-200`}
            // disabled={isAlreadyInCart}
          >
            {isAlreadyInCart ? "Booked" : "Book Now"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
